import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { styled } from '@mui/material/styles'

import {
  Tabs,
  Tab
} from '@mui/material'
import Table from '@views/adminEmployee/table/Table'

import {
	adminGetGroupList,
} from '@store/admin/company'

const StyledTabs = styled(Tabs)({
  marginBottom: 20,
  '& .MuiTabs-indicator': {
  	backgroundColor: '#000'
  }
})

const StyledTab = styled(Tab)({
  '&.Mui-selected': {
  	color: '#000',
  	fontWeight: 'bold'
  }
})

const AdminEmployee = () => {
	const dispatch = useDispatch()
	const {
		groupList,
	} = useSelector(store => store.companyAdmin)
	const [ groupId, setGroupId ] = useState(0)
	const [ groupName, setGroupName ] = useState('')

  const handleChange = (event, newValue) => {
    setGroupId(newValue)
		setGroupName(event.target.outerText)
  }

	useEffect(() => {
		const getGroupList = async () => {
			const response = await dispatch(adminGetGroupList())

			setGroupId(response.payload.data[0]?.groupId)
			setGroupName(response.payload.data[0]?.groupName)
		}
		getGroupList()
	}, [ dispatch ])

	return (
		<div>
			<h2>특관인 변동사항 관리</h2>

			{!!groupId && <><StyledTabs
			  value={groupId}
			  onChange={handleChange}
			  variant="scrollable"
			  scrollButtons="auto"
			  aria-label="scrollable auto tabs"
			>
				{
					groupList.map(item => {
						return (
							<StyledTab label={item.groupName} key={item.groupId} value={item.groupId} />
						)
					})
				}
			</StyledTabs>
			<Table 
				groupId={groupId}
				groupName={groupName}
			/></>}
		</div>
	)
}

export default AdminEmployee